import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import fakeJSON from '../utils/fakeJSON';
import observer from '../utils/observer';

const Testimonials = () => {
  const fakeData = fakeJSON();
  let [curSlide, setCurSlide] = useState(0);
  const maxSlide = fakeData.length;

  const refValue = useRef(null);

  useEffect(() => {
    observer(refValue, 'section-hidden');
  }, [refValue]);

  const nextSlide = () => {
    if (curSlide === -((maxSlide - 1) * 100)) setCurSlide(0);
    else {
      setCurSlide(prev => prev - 100);
    }
  };
  const prevSlide = () => {
    if (curSlide === 0) setCurSlide(-((maxSlide - 1) * 100));
    else setCurSlide(prev => prev + 100);
  };

  // let startPosition;
  // const touchStart = e => {
  //   startPosition = e.targetTouches[0].pageX;
  //   // Swipe Start Position
  // };
  // const touchEnd = e => {
  //   if (e.changedTouches[0].pageX > startPosition) {
  //     nextSlide();
  //     // you swiped left
  //   }
  //   if (e.changedTouches[0].pageX < startPosition) {
  //     prevSlide();
  //     // you swiped right
  //   }
  // };

  return (
    <div id='testimonial' className="testimonials-container section-hidden" ref={refValue}>
      <div className="testimonials-headers">
        <div className="testimonials-header">
          Don't just take our words for it
        </div>
        <div className="testimonials-sub-header">
          {/* See what real shredders are saying about Fitness Space */}
          Real users, real results
        </div>
      </div>
      <div className="testimonials-slider">
        <div className=" prev-arrow" onClick={prevSlide}>
          <FontAwesomeIcon
            icon={faArrowLeft}
            className="testimonials-slide-buttons"
          />
        </div>
        <div className="testimonial-cards">
          <div className="background-card-1 testimonial-card"></div>
          <div className="background-card-2 testimonial-card"></div>
          <div
            className="testimonial-card-details-container testimonial-card"
            // onTouchStart={touchStart}
            // onTouchEnd={touchEnd}
          >
            {fakeData.map((value, i) => {
              return (
                <div
                  key={i}
                  className={`testimonial-card-details`}
                  style={{
                    transform: `translateY(${curSlide}%`,
                  }}
                >
                  <div className="testimonial-image-container">
                    <img
                      src={value.image}
                      alt="testimonial"
                      className="testimonial-image"
                    />
                  </div>
                  <div className="testimonial-review">{value.review}</div>
                  <div className="testimonial-reviewer">{value.name}</div>
                </div>
              );
            })}
          </div>
        </div>
        <div className=" next-arrow" onClick={nextSlide}>
          <FontAwesomeIcon
            icon={faArrowRight}
            className="testimonials-slide-buttons"
          />
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
